<template>
    <oss-dialog
        v-model="dialog"
        title="Utilisateurs"
        :min-width="'800px'"
        :max-width="'800px'"
        :actions="actions"
        @previous="previousStep"
        :previous-display="['createUser', 'mergeUser'].includes(currentStep)"
    >
        <v-window v-model="currentStep">
            <v-window-item value="selectUser">
                <SelectUserV2
                    ref="selectUser"
                    :withEmail="true"
                    :companyId="selectedCompany.id"
                    :type="type"
                    :actions="actions"
                    height="56vh"
                    @users-to-merge="usersMerge"
                    @create-user-step="createUserStep"
                    @disable-merge-button="disableMerging"
                    @edit-user="editUser($event)"
                    @emit-actions="setActions()"
                />
            </v-window-item>

            <v-window-item value="createUser">
                <UserEditionLight
                    ref="userEdition"
                    :actions="actions"
                    :id="user.id"
                    @user-upserted="userUpserted()"
                />
            </v-window-item>

            <v-window-item value="mergeUser">
                <MergeUsers
                    :actions="actions"
                    :userIdsToMerge="userIdsToMerge"
                    @user-to-keep="userToKeep"
                    @merge-done="previousStep"
                />
            </v-window-item>
        </v-window>
    </oss-dialog>
</template>
<script lang="ts">
import { DialogAction } from "../../services/dialogAction";
import SelectUserV2 from "./SelectUserV2.vue";
import MergeUsers from "./MergeUsers.vue";
import UserEditionLight from "./UserEditionLight.vue";
import { Component, Model, toNative, Vue, Watch, Ref } from "vue-facing-decorator";

@Component({
    components: {
        SelectUserV2,
        MergeUsers,
        UserEditionLight,
    },
})
export class UsersDialog extends Vue {
    @Model({ default: false }) value: boolean;
    @Ref("selectUser") selectUser: any;
    @Ref("userEdition") userEdition: any;

    actions = {
        action: new DialogAction(),
    };

    searchUser = "";

    currentStep = "selectUser";

    userIdsToMerge = [];

    user = {
        id: "",
    };

    type = "NATURAL_PERSON";

    disableUsersToMerge = true;

    // deleteMode = false

    // orphelinUsers = []

    beforeMount() {
        this.setActions();
    }

    // @Apollo({
    //     query: ACCOUNTING_COMPANY_OF_COMPANY,
    //     variables() {
    //         return {
    //             companyId: this.currentUser.company.id
    //         }
    //     },
    //     skip() {
    //         return !this.currentUser.id || this.isAccountingUser
    //     },
    //     specificResult({ data, loading, networkStatus }: any) {
    //         if (!loading) {
    //             if (data && data.companies && data.companies.length) {
    //                 this.accountingFirm = data.companies[0]
    //             }
    //         }
    //     }
    // })
    // accountingFirm = null

    // get companyId() {
    //     if (this.isAccountingUser && this.currentUser?.company?.id) {
    //         return this.currentUser.company.id
    //     }
    //     if (!this.isAccountingUser && this.accountingFirm) {
    //         return this.accountingFirm.id
    //     }
    //     return ""
    // }

    get selectedCompany() {
        return this.$store.state.selected_company;
    }

    get dialog() {
        return this.value;
    }

    get isValid() {
        return this.userEdition?.isValid;
    }

    set dialog(event) {
        this.value = event;
    }

    disableMerging(event) {
        if (event) {
            this.disableUsersToMerge = true;
        } else {
            this.disableUsersToMerge = false;
        }
    }

    usersMerge(users) {
        this.userIdsToMerge = users;
        if (this.userIdsToMerge.length > 1) {
            this.disableUsersToMerge = false;
        } else if (this.userIdsToMerge.length <= 1) {
            this.disableUsersToMerge = true;
        }
    }

    createUserStep(stepFromChild) {
        if (stepFromChild === "createUser") {
            this.currentStep = "createUser";
        }
    }

    previousStep() {
        switch (this.currentStep) {
            case "selectUser": {
                this.currentStep = "selectUser";
                break;
            }
            case "createUser": {
                this.currentStep = "selectUser";
                break;
            }
            case "mergeUser": {
                this.currentStep = "selectUser";
                break;
            }
        }
    }

    userToKeep(user) {
        if (user) {
            this.disableUsersToMerge = false;
        }
    }

    editUser(user) {
        if (user) {
            this.user = user;
            this.currentStep = "createUser";
        }
    }

    // setDelete(event) {
    //     this.deleteMode = (event === "showOrphelinUsers")
    //     this.setActions()
    // }

    // setOrphelinUsers(event) {
    //     debugger
    //     this.orphelinUsers = event
    // }

    @Watch("currentStep")
    setActions() {
        debugger;
        if (this.currentStep === "selectUser") {
            if (this.actions?.action) {
                this.actions.action.function = () => {
                    this.currentStep = "mergeUser";
                };
                // @ts-ignore
                this.actions.action.disabled = () => {
                    return !!this.disableUsersToMerge;
                };
                this.actions.action.title = "Fusionner";
            }
        } else if (this.currentStep === "createUser") {
            if (this.user?.id) {
                this.actions.action.title = "Modifier";
            } else {
                this.actions.action.title = "Créer";
            }
            this.actions.action.function = () => {
                this.userEdition.upsert();
            };
            this.actions.action.disabled = () => {
                return !this.isValid;
            };
        }
    }

    @Watch("currentStep")
    onCurrentStepChange(newValue) {
        if (newValue === "selectUser") {
            this.user = {
                id: "",
            };
        }
    }

    userUpserted() {
        this.currentStep = "selectUser";
        this.user = {
            id: "",
        };
        this.$refs.selectUser.refresh();
    }
}

export default toNative(UsersDialog);
</script>
